var newsletter = new function() {

    var me = this;

    this.bindEvents = function() {
        $("[data-form-newslettersubscribe]").bind("submit", function() {
            var form = $(this);
            var params = {
              'email': form.find("input[type='email']").val(),
              'lang': $('html').attr('lang'),
              '_token': window.Laravel.csrfToken
            };
            if($(this).valid()){
              $.post("/module/newsletter/subscribe",params, function(response) {
                  if(parseInt(response.code) == 1)
                    form.find("input[type='email']").val('');
                  $("[data-form-newslettermsg]").html(response.msg);
              },"json");
            }
            return false;
        });
    };
}

$(document).ready(function() {
    newsletter.bindEvents();
});

$(document).ready(function () {
  var elements = document.querySelectorAll('.js-gallery');
  if(elements && elements.length>0){
    for(var i=0;i<elements.length;i++){
        $(".js-gallery").eq(i).magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: 'Ładowanie #%curr%...',
            mainClass: 'mfp-with-zoom',
            tClose: 'Zamknij',
            removalDelay: 400,
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                tPrev: 'Poprzednie',
                tNext: 'Następne',
                preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
                tCounter: '<span class="mfp-counter">%curr% z %total%</span>'
            },
            image: {
                tError: '<a href="%url%">Zdjęcie #%curr%</a> nie może być załadowane.',
                titleSrc: function (item) {
                    return item.el.attr('title');
                }
            }
        });
    }
  }
});

$(document).ready(function(){

    var elements = $("[data-galleryvideo]");

    if( elements.length > 0 ) {
      if ($('.main__sidebar').length) {
        for(var i=0; i<elements.length;i++){
          $(elements[i]).slick({
              dots: false,
              vertical: true,
              slidesToShow: 2,
              slidesToScroll: 1,
              verticalSwiping: true,
              infinite: false
          });
        }
        $('.js-videoSlider').each(function(){
            if ( $(this).find('.slick-slide').length <= 2 ) {
              $(this).closest('.videoSlider').addClass('short');
            }
        });
      } else {
        for(var i=0; i<elements.length;i++){
          $(elements[i]).slick({
              dots: false,
              vertical: true,
              slidesToShow: 2,
              slidesToScroll: 1,
              verticalSwiping: true,
              infinite: false
          });
        }
        $('.js-videoSlider').each(function(){
            if ( $(this).find('.slick-slide').length <= 2 ) {
              $(this).closest('.videoSlider').addClass('short');
            }
        });
      }
    }

    $("[data-videourl]").on("click", function () {
        var el = $(this);
        var url = el.data("videourl");
        var instance = el.closest('.videoSlider__right').parent();
        instance.find('[data-target]').attr("src", url);
        instance.find('.videoSlide .slick-slide').removeClass('slick-current');
        el.closest('.slick-slide').addClass('slick-current');
    });

    $("[data-videourl]").eq(0).trigger("click");

});

$(document).ready(function(){
    $(".contentBlock").find("table").wrap("<div class='styledTable'></div>");
});
$(document).ready(function(){
    var popupLink = $(".hiddenPopup");
    if(popupLink.length == 1){
      var type = popupLink.data("type");

      if(type!=null){
        type = type.replace(/\s*$/,"");

        if(type === "inline") {
            popupLink.magnificPopup({
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                items: {
                    src: '#popup',
                    type: type
                }
            });
        } else{
            popupLink.magnificPopup({
                type: 'iframe',
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                iframe: {
                    markup: '<div class="mfp-iframe-scaler">' +
                    '<div class="mfp-close"></div>' +
                    '<iframe id="player" class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                    '</div>',
                    patterns: {
                        youtube: {
                            index: 'youtube.com/',
                            id: 'v=',
                            src: 'h%id%&autoplay=1'
                        }
                    }
                }
            });
        }
      }
    }
});

$(window).on('load',function () {
    $(".hiddenPopup").trigger("click");
});

$(document).ready(function () {
    var el = $('[data-cookies]');

    $('[data-closecookies]').on('click', function () {
        el.fadeOut();
        Cookies.set('cookies_info', '1', {expires: 12});
    });

    var myCookie = Cookies.get('cookies_info');
    if (myCookie === undefined) {
        el.show();
    }
});
var category = new function() {
    var me = this;
    this.containerAmong;
    this.durningRequest = false;

    this.showNext = function(el) {
        var categoryBox = $(el).closest("[data-category-box]");
        var currentPage = parseInt(categoryBox.attr("data-category-currentpage"));
        var container = categoryBox.find("[data-category-container]");
        /*if (container.eq(currentPage).length > 0) {
            container.eq(currentPage).fadeIn();
        }
        if (container.eq(currentPage + 1).length == 0) {
            $(el).fadeOut();
        }
        $(el).closest("[data-category-box]").attr("data-category-currentpage", currentPage + 1);*/
        var data = {
            category_id: categoryBox.data("category-id"),
            page_nr: parseInt(categoryBox.data("category-page")) + 1,
            _token: Laravel.csrfToken,
            language: $('html').attr('lang')
        };

        if(typeof categoryBox.find("[data-category-thumbnail]")!=="undefined" && categoryBox.attr("data-category-thumbnail")!=""){
          data.thumbnail = categoryBox.attr("data-category-thumbnail");
        }

        if(typeof categoryBox.find("[data-module]")!=="undefind"){
          data.module = categoryBox.attr("data-module");
        }

        if(typeof categoryBox.find("[data-listing]")!=="undefind"){
          data.listing = categoryBox.attr("data-listing");
        }

        var requestParams = document.location.href.split('/').pop().split(',');
        if(requestParams.length > 1 && parseInt(requestParams[1])>=1 && parseInt(requestParams[1])<=12)
          data.month = requestParams[1];
        if(requestParams.length == 2)
          data.year = requestParams[1];
        else if(requestParams.length > 2)
          data.year = requestParams[2];

        if(!me.durningRequest)
          me.getPosts(data,categoryBox);
    };

    /**
     * data:
     *  category_id
     *  page_nr
     *  _token
     */
    this.getPosts = function(data,categoryBox){
      me.durningRequest = true;
      $.ajax({
          url: "/module/postfromcategory",
          method: "POST",
          data: data,
          dataType: "json",
          success: function (data) {
              if (data.posts.length == 0) {
                  $("[data-category-loadpage]").remove();
              } else {
                  var template = $("#entry-template").html();
                  var stone = Handlebars.compile(template)(data);
                  var $items = $.parseHTML(stone);
                  if(data.posts.length<parseInt(categoryBox.data('category-perpage')))
                    $("[data-category-loadpage]").remove();

                  categoryBox.find("[data-category-container]").append($items);
                  categoryBox.data('category-page', data.page);
                  $(".loader").data("offset", data.offset);
              }
              me.durningRequest = false;

              if(data.next==0)
                categoryBox.find('div[data-category-loadpage]').addClass('hidden');
          }
      });
    };

    this.bindEvents = function() {
        $("[data-category-loadpage]").bind("click", function() {
            me.showNext($(this));
        });
    };

};

$(document).ready(function () {
    category.bindEvents();

    $('.loader').on('inview', function (event, isInView) {
        if (isInView) {
            var data = {
                category_id: $("[data-category-id]").data("category-id"),
                page_nr: parseInt($("[data-category-page]").data("category-page")) + 1,
                _token: Laravel.csrfToken
            };

            category.getPosts(data);
        }
    });
});

Handlebars.registerHelper('dotdotdot', function(str,length) {
  if (str.length > length)
    return str.substring(0,length-1) + '...';
  return str;
});

Handlebars.registerHelper('compare', function (v1, operator, v2, options) {
   'use strict';
   console.log(options);
   var operators = {
     '==': v1 == v2 ? true : false,
     '===': v1 === v2 ? true : false,
     '!=': v1 != v2 ? true : false,
     '!==': v1 !== v2 ? true : false,
     '>': v1 > v2 ? true : false,
     '>=': v1 >= v2 ? true : false,
     '<': v1 < v2 ? true : false,
     '<=': v1 <= v2 ? true : false,
     '||': v1 || v2 ? true : false,
     '&&': v1 && v2 ? true : false
   }
   if (operators.hasOwnProperty(operator)) {
     if (operators[operator]) {
       return options.fn(this);
     }
     return options.inverse(this);
   }
   return console.error('Error: Expression "' + operator + '" not found');
});

Handlebars.registerHelper('indexof', function(array,index) {
  if(array.length > index)
    return array[index];
  else
    return "";
});

$(document).ready(function () {
  $('.js-openMenu').on("click", function () {
    $(this).toggleClass('active');
    $('.mobileMenu').toggleClass('opened');
    $('body').addClass('noscroll');
  });

  $('.js-close').on("click", function () {
    $('.mobileMenu').removeClass('opened');
    $('body').removeClass('noscroll');
  });

  $('body').on("click", '.js-prev', function () {
    
    var el = $(this);
    $(".mobileMenu ul.opened").removeClass("opened");
    $("[data-menu].actived").removeClass("actived");
    $(".js-prev").remove();
  });

  $('.mobileMenu li').each(function() {
    if ( $(this).find('ul').length ) {
      $(this).addClass('withSubmenu');
    }
  });
  

  $("[data-menu]:not(.actived)").on("click", function (e) {
    if( $(this).hasClass('actived')) { 
      window.location.href = $(this).attr('href');
    } else {
      e.preventDefault();
      var el = $(this);
      el.addClass("actived");
      el.next('ul').addClass("opened");
      $('.mobileMenu__tools').append("<a class='js-prev mobilePrev'></a>");
    }
    
  });

  $('.js-searchBox .searchBox__icon').on('click', function() {
    $(this).parent().toggleClass('active');
    $('.js-searchBox input').focus();
    $('.mobileMenu__language').toggleClass('hide');
  });

});

// main slider
var $slider =  $('.js-slider');
function myHandler() {
  $slider.slick('slickPlay');
}
function playVideoSlide(slick,currentSlide,mute){

  var slide = $(slick.$slides.get(currentSlide));
  if(slide.find('video').length){
    if(slide.find('video')[0].readyState >= 2) {

      if(typeof mute !=="undefined")
        slide.find('video')[0].muted = true;
      else
        slide.find('video')[0].muted = false;

      slide.find('video')[0].play();
      $slider.slick('slickPause');

    } else {
      slide.find('video')[0].oncanplay = function() {
        if(typeof mute !=="undefined")
          slide.find('video')[0].muted = true;
        else
          slide.find('video')[0].muted = false;
        slide.find('video')[0].play();
        $slider.slick('slickPause');
      }
    }

    slide.find('video')[0].addEventListener('ended',function() {
      myHandler;
      $slider.slick('slickNext');
    },false);
  }
}

$slider.on('init reInit', function(event, slick) {
  $('.slick-slide:not(.slick-current)').removeClass('slider__item--visible');
  $('.js-slider .slick-current').addClass('slider__item--visible');
  playVideoSlide(slick,0,1);
});
$slider.on('afterChange', function(event, slick, currentSlide) {
  var slide = $(slick.$slides.get(currentSlide));
  $('.slick-slide:not(.slick-current)').removeClass('slider__item--visible');
  $('.js-slider .slick-current').addClass('slider__item--visible');
  playVideoSlide(slick,currentSlide,1);

  if(!slide.find('video').length){
    $slider.slick('slickPlay');
  }
});
$slider.on('beforeChange', function(event, slick, currentSlide,nextSlide) {
  var slide = $(slick.$slides.get(currentSlide));
  if(slide.find('video').length){
    slide.find('video')[0].pause();
  }
});

$slider.slick({
  arrows: true,
  speed: 700,
  autoplaySpeed: 7000,
  dots: true,
  infinite: true,
  autoplay: true,
  vertical: true,
  verticalSwiping: true,
  slidesToScroll: 1
  // adaptiveHeight: true -> for videos
});

$(".slider__textItem--2").lettering('words');

//slider--3 dots
if ( $('.js-slider--3').length ) {
    $('.js-slider--3 .slick-dots button').each(function(i) {
        i++;
        n=i;
        $(this).attr('data-number',++i).append('<span>0'+ n +'</span>');
    });
}
 // imageslider
 var elements = document.querySelectorAll('.js-sliderGallery');
 if ( elements.length>0){
   $('.js-sliderGallery').slick({
       arrows: true,
       speed: 700,
       autoplaySpeed: 7000,
       dots: true,
       infinite: true,
       autoplay: true,
       slidesPerRow: 5,
       rows: 2,
       responsive: [
         {
           breakpoint: 678,
           settings: {
             slidesPerRow: 2,
             rows: 2,
           }
         }
       ]
   });
 }
// scrolledGallery for mobiles
let scrolledGallery = function() {
    $('.js-scrolledGallery').slick({
        arrows: true,
        speed: 700,
        fade: true,
        autoplaySpeed: 7000,
        dots: true,
        infinite: true,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1240,
            settings: {
              dots: false
            }
          }
        ]
    });
}
if ($(window).width() < 600) {
    scrolledGallery();
}
$(window).on('resize', function(){
    if ($(window).width() < 600) {
        scrolledGallery();
    }
});
//offerSlider
var element = document.querySelector('.js-offerSlider');
if ( $('.js-offerSlider').length ){
  $('.js-offerSlider').slick({
      arrows: true,
      speed: 1400,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 4
          }
        },
        {
          breakpoint: 800,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: true,
              fade: false
          }
        },
        {
          breakpoint: 600,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
              fade: true
          }
        }
      ]
  });
}

//logoSlider
if ( $('.js-logoSlider').length ){
  $('.js-logoSlider').slick({
      arrows: true,
      speed: 700,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: false,
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 4
          }
        },
        {
          breakpoint: 900,
          adaptiveHeight: false,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2
          }
        }
        ,
        {
          breakpoint: 600,
          adaptiveHeight: true,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
        }
      ]
  });
}
//productSlider
if ( $('.js-productSlider').length ) {
  $('.js-productSlider').slick({
      speed: 700,
      fade: true,
      autoplaySpeed: 7000,
      infinite: true,
      autoplay: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.slider-nav-thumbnails',
      responsive: [
        {
          breakpoint: 1240,
          settings: {
            dots: false
          }
        }
      ]
  });
  $('.slider-nav-thumbnails').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.js-productSlider',
    dots: true,
    focusOnSelect: true
  });
}

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-webp-setclasses !*/
 !function(e,n,A){function o(e,n){return typeof e===n}function t(){var e,n,A,t,a,i,l;for(var f in r)if(r.hasOwnProperty(f)){if(e=[],n=r[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(A=0;A<n.options.aliases.length;A++)e.push(n.options.aliases[A].toLowerCase());for(t=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],l=i.split("."),1===l.length?Modernizr[l[0]]=t:(!Modernizr[l[0]]||Modernizr[l[0]]instanceof Boolean||(Modernizr[l[0]]=new Boolean(Modernizr[l[0]])),Modernizr[l[0]][l[1]]=t),s.push((t?"":"no-")+l.join("-"))}}function a(e){var n=u.className,A=Modernizr._config.classPrefix||"";if(c&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+A+"no-js(\\s|$)");n=n.replace(o,"$1"+A+"js$2")}Modernizr._config.enableClasses&&(n+=" "+A+e.join(" "+A),c?u.className.baseVal=n:u.className=n)}function i(e,n){if("object"==typeof e)for(var A in e)f(e,A)&&i(A,e[A]);else{e=e.toLowerCase();var o=e.split("."),t=Modernizr[o[0]];if(2==o.length&&(t=t[o[1]]),"undefined"!=typeof t)return Modernizr;n="function"==typeof n?n():n,1==o.length?Modernizr[o[0]]=n:(!Modernizr[o[0]]||Modernizr[o[0]]instanceof Boolean||(Modernizr[o[0]]=new Boolean(Modernizr[o[0]])),Modernizr[o[0]][o[1]]=n),a([(n&&0!=n?"":"no-")+o.join("-")]),Modernizr._trigger(e,n)}return Modernizr}var s=[],r=[],l={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var A=this;setTimeout(function(){n(A[e])},0)},addTest:function(e,n,A){r.push({name:e,fn:n,options:A})},addAsyncTest:function(e){r.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var f,u=n.documentElement,c="svg"===u.nodeName.toLowerCase();!function(){var e={}.hasOwnProperty;f=o(e,"undefined")||o(e.call,"undefined")?function(e,n){return n in e&&o(e.constructor.prototype[n],"undefined")}:function(n,A){return e.call(n,A)}}(),l._l={},l.on=function(e,n){this._l[e]||(this._l[e]=[]),this._l[e].push(n),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e])},0)},l._trigger=function(e,n){if(this._l[e]){var A=this._l[e];setTimeout(function(){var e,o;for(e=0;e<A.length;e++)(o=A[e])(n)},0),delete this._l[e]}},Modernizr._q.push(function(){l.addTest=i}),Modernizr.addAsyncTest(function(){function e(e,n,A){function o(n){var o=n&&"load"===n.type?1==t.width:!1,a="webp"===e;i(e,a&&o?new Boolean(o):o),A&&A(n)}var t=new Image;t.onerror=o,t.onload=o,t.src=n}var n=[{uri:"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=",name:"webp"},{uri:"data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==",name:"webp.alpha"},{uri:"data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",name:"webp.animation"},{uri:"data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=",name:"webp.lossless"}],A=n.shift();e(A.name,A.uri,function(A){if(A&&"load"===A.type)for(var o=0;o<n.length;o++)e(n[o].name,n[o].uri)})}),t(),a(s),delete l.addTest,delete l.addAsyncTest;for(var p=0;p<Modernizr._q.length;p++)Modernizr._q[p]();e.Modernizr=Modernizr}(window,document);
$(document).ready(function(){

  // go to form message
  if ( $('.formErrors__item').length ) {
    $('html, body').animate({
        scrollTop:  $('.formErrors__item').first().offset().top - 200
    }, 600);
  }

  //language - select
  if ($('.languageBox__select').length) {
    $('.languageBox__select').on('click', function() {
        $('.languageBox__list').toggleClass('visible');
        $('.languageBox__select').toggleClass('active');
        return false;
    });
  }
  
  //aos
  if ( $('[data-aos]').length ) {
      AOS.init({
          offset: 50,
          duration: 500,
          disable: 'mobile'
      });
  }

  // lazy loads elements with default selector as '.lozad'
  if ($('.lozad').length) {
    const observer = lozad(); 
    observer.observe();
  }
  
  // scrolled menu
  if ($(window).width()<1240){
          $('.js-header').addClass('header--scrolled');
  } else {
      $('.js-header').removeClass('header--scrolled');
  }

  // relax init
  if ($('.rellax').length) {
      var rellax = new Rellax('.rellax', {
        center: true
        // wrapper: '.rellax-parent',
        // relativeToWrapper: true,
      });
  }

  // js-up
  $(".js-up").on("click", function () {
      var body = $("html, body");
      body.stop().animate({scrollTop: 0}, 1500, 'swing');
  });

  //go to form
  if ($('.js-gotoform').length) {
    $('.js-gotoform').on('click', function(){
        let anchor = $('.footer__form');
        if (anchor.length) {
            $('html, body').animate({
                scrollTop:  $(anchor).offset().top
            }, 600);
            return false;
        }
    });
  }
  
  //go to comment form
  if ($('.js-comments__addButton').length) {
    $('.js-comments__addButton').on('click', function(){
      let anchor = $('#commentForm');
      $('html, body').animate({
          scrollTop:  $(anchor).offset().top - 100
      }, 600);
      return false;
    });
  }

  //go to map
  if ($('.js-gotomap').length) {
    $('.js-gotomap').on('click', function(){
        let anchor = $('.contact__map');
        if (anchor.length) {
            $('html, body').animate({
                scrollTop:  $(anchor).offset().top - 100
            }, 600);
            return false;
        }
    });
  }

  // scrolled menu
  if ($(window).scrollTop() > 0) {
    $('.js-header').addClass('header--scrolled');
    if ($('.hamburger--2').length) {
      $('.hamburger--2').on("click", function () {
        //$(this).toggleClass('active');
        $('.header--3').removeClass('header--scrolled');
      });
    }
  } else {
    if ( $(window).width()>1240 && $('.hamburger--2').length==0 ){
      $('.js-header').removeClass('header--scrolled');
    }
  }

  //search
  $('.js-header__search').on('click', function(){
      $('.header .header__searchBox form').toggleClass('header__searchBoxForm--hidden');
      $('.header .header__searchBox').slideToggle(300);
  });
  $('.js-header__searchBoxIcon').on('click', function(){
    $('[data-search-form]').submit();
  });


  //filters in offer
  if ($("[data-filter-submit]").length) {
    $("[data-filter-submit]").click(function(){
      var filters = $("[data-filter]"),name,value,counter=1,type;
      var url = top.location.href.split(",");
      var checkedFilters = new Array();
      url = url[0]+",1&";
      for(var i=0;i<filters.length;i++){
        id = filters.eq(i).attr('data-filter');
        name = filters.eq(i).attr('data-filter-field');
        type = filters.eq(i).attr('type');
  
        if($.inArray(id,checkedFilters)===-1){
          value = "";
          if($("[data-filter='"+id+"']").length>1){
            var subFilters = $("[data-filter-field='"+name+"']");
            for(var j=0;j<subFilters.length;j++){
              if(type=="checkbox"){
                value+= subFilters.eq(j).is(":checked") ? subFilters.eq(j).val()+"," : "";
              }else if(subFilters.eq(j).val()!=""){
                value+= subFilters.eq(j).val()+",";
              }
            }
            if(value[value.length-1] == ","){
              value = value.slice(0,-1);
            }
          }else if(type=="checkbox"){
            value = filters.eq(i).is(":checked") ? filters.eq(i).val() : "";
          }else{
            value = filters.eq(i).val();
          }
  
          if(typeof value!=="undefined" && value!="" && value!=","){
            if(typeof filters.eq(i).attr('data-filter-name')==="undefined"){
              url+= "filter_" + counter + "=" + name + "&value_" + counter + "=" + value;
              if(typeof filters.eq(i).attr('data-filter-operator')!=="undefined"){
                url+= "&operator_" + counter + "=" + filters.eq(i).attr('data-filter-operator');
              }
              url+="&";
              counter++;
            }else{
              url+= filters.eq(i).attr('data-filter-name') + "=" + value+"&";
            }
          }
  
          checkedFilters.push(name);
        }
      }
      if($("[data-filter-sort]").find("option:selected").val()!=""){
        url+= "sort="+$("[data-filter-sort]").find("option:selected").val()+"&";
        url+= "sort_order="+$("[data-filter-sort]").find("option:selected").attr('data-sort-order')+"&";
      }
  
      if(url[url.length-1] == "&"){
        url = url.slice(0,-1);
      }
      top.location.href = url;
    });
  
    $("[data-filter-sort]").change(function(){
      $("[data-filter-submit]").trigger('click');
    });
  
    $("[data-filter-clear]").click(function(){
      var url = top.location.href.split(",");
      top.location.href = url[0];
    });
  }

  // sticky
  if ( $('.sidebarMenu > div').length && ( $(window).width() > 1024 ) && ( $('.main__modules').height() >= $('.main__sidebar div[data-sticky-class]').height()) )  {
    let sticky = new Sticky('.sidebarMenu > div');
  }

  // file input
  if ( $('.styledFormItems--file').length) {
    let pullfiles = function(){
      let fileInput = document.querySelector(".styledFormItems--file input");
      let filesContainer = document.querySelector('.styledForm__files');
      let files = fileInput.files;
      let fl = files.length;
      let i = 0;
      while ( i < fl) {
          let file = files[i];
          let element = document.createElement("span");
          element.appendChild(document.createTextNode(file.name));
          filesContainer.appendChild(element);
          i++;
      }
    }  

    document.querySelector(".styledFormItems--file input").onchange = pullfiles;

    $(document).on('click','.styledForm__files span', function(){
      // var newFileList = $(".styledFormItems--file input").prop("files");
      $(this).remove();
    });
  }

  $(window).on('mousemove', function(e) {
    var w = $(window).width();
    var h = $(window).height();
    var offsetX = 0.5 - e.pageX / w;
    var offsetY = 0.5 - e.pageY / h;

    $(".parallaxImg").each(function(i, el) {
      var offset = parseInt($(el).data('offset'));
      var translate = "translate3d(" + Math.round(offsetX * offset) + "px," + Math.round(offsetY * offset) + "px, 0px)";

      $(el).css({
        '-webkit-transform': translate,
        'transform': translate,
        'moz-transform': translate
      });
    });
  });
  
}); // end document ready

$(window).on('load', function(){

});

$(window).on("scroll", function () {

// js-up
var scroll = $(window).scrollTop();
if (scroll > 600) {
    $(".js-up").addClass("visible");
} else {
    $(".js-up").removeClass("visible");
}

// scrolled menu
if ($(window).scrollTop() > 0){
  $('.js-header').addClass('header--scrolled');
 } else {
  if ($(window).width()>1240){
    $('.js-header').removeClass('header--scrolled');
  }
}

}); // end onscroll

var validator = new function() {
    this.methods = function() {
        jQuery.validator.addMethod("phone", function(value, element) {
            var slug = /^[0-9\-]+$/;
            return slug.test(value) && value.length == 9;
        }, Laravel.lang.validation.phone);
    };
};

$(document).ready(function() {
    validator.methods();

    $("[data-search-form] input").bind("keyup",function(){
      var value = $(this).val();

      if(value.length>2){
        var currentRequest = null;

        currentRequest = jQuery.ajax({
            type: 'POST',
            data: {
              'phrase':value,
              '_token': window.Laravel.csrfToken,
              'lang': $('html').attr('lang')
            },
            url: '/module/search/hint',
            beforeSend : function()    {
                if(currentRequest != null) {
                    currentRequest.abort();
                }
            },
            success: function(data) {
                $("[data-search-form] ul").html('');
                if(Object.keys(data.results).length>0){
                  for (var prop in data.results) {
                    // for(var item in data.results[prop]){
                      var template = $("#search-hint-template").html();
                      var stone = Handlebars.compile(template)({"results":data.results[prop]});
                      var items = $.parseHTML(stone);
                      // console.log(data.results);
                      // console.log(Laravel.lang.search);
                      $("[data-search-hintcontainer]").append("<li><h2>"+Laravel.lang.search[prop]+"</h2></li>");
                      $("[data-search-hintcontainer]").append(items);
                    // }
                    $("[data-search-hintcontainer]").addClass('visible');
                  }
                }else{
                  $("[data-search-hintcontainer]").removeClass('visible')
                }
            },
            error:function(e){
              // Error
            }
        });
      }else{
        $("[data-search-hintcontainer]").removeClass('visible')
      }
    });
});

var message = new function() {
    this.show = function(type, message) {
        $.notify({
            message: message
        }, {
            type: type,
            placement: {
                from: "bottom",
                align: "right"
            },
            delay: 5000
        });
    };
};

var form = new function() {
    this.validate = function() {
      if(typeof $("[data-formvalidation]").validate != "undefined"){
        $("[data-formvalidation]").bind('submit',function(){
          var langs = $("[data-metagenerator-trigger]").length;
          if(langs>0){
            var elements = document.querySelectorAll("[data-metagenerator-trigger]");
            var hasValue = false;
            var errorMsg = "";
            var langId;
            if(elements.length>0)
              var parent = $("[data-metagenerator-trigger]").eq(i).closest(".tab-pane");
            for(var i=0;i<elements.length;i++){
              if(elements[i].getAttribute('disabled') === "disabled"){

              }else{
                langId = elements[i].getAttribute('data-lang-id');
                errorMsg+= elements[i].getAttribute('data-formvalidation-label') + ', ';
                if(elements[i].value!=""){
                  hasValue = true;
                  parent.find("input[name='title["+langId+"]']").addClass('requried').attr('required','required');
                  parent.find("input[name='name["+langId+"]']").addClass('requried').attr('required','required');
                  parent.find("input[name='url["+langId+"]']").addClass('requried').attr('required','required');
                }else{
                  parent.find("input[name='title["+langId+"]']").removeClass('requried').removeAttr('required');
                  parent.find("input[name='name["+langId+"]']").removeClass('requried').removeAttr('required');
                  parent.find("input[name='url["+langId+"]']").removeClass('requried').removeAttr('required');
                }
              }
            }

            if(!hasValue){
              message.show("danger",window.Laravel.lang.validation.insert_one_of+': '+errorMsg.trim().slice(0,-1));
              return false;
            }else{
              return true;
            }
          }else{
            return true;
          }
        });
        $("[data-formvalidation]").validate({
            "ignore": [],
            "errorPlacement": function(error, element) {
                console.log(element[0].tagName);
                if (typeof element.attr("data-lang-input") !="undefined" && element.is(":hidden")){
                  //nie pokazujemy komunikatów dla ukrytych langów
                }else if (typeof element.attr("type") != "undefined" && element.attr("type") == "radio") {
                    error.insertAfter(element.parent().find('label'));
                }else if (typeof element.attr("type") != "undefined" && element.attr("type") == "file") {
                    error.insertAfter(element.parent());
                }else if(element[0].tagName.toLowerCase()=="select"){
                    error.insertAfter(element.parent().find(".select2:last"));
                } else {
                    error.insertAfter(element);
                }
            },
            "invalidHandler": function(form, validator) {
                var errors = validator.numberOfInvalids();
                if (errors) {
                    var response = Laravel.lang.validation.invalid, msg;
                    if (validator.errorList.length > 0 && $(this).find("[data-formvalidation-label]").length > 0) {
                        response+= ":<ul>";
                        for (x = 0; x < validator.errorList.length; x++) {
                            msg = validator.errorList[x].message;
                            response+= "<li><b>"+$(validator.errorList[x].element).attr("data-formvalidation-label")+"</b> - "+msg[0].toLowerCase()+msg.slice(1,msg.length)+"</li>";
                        }
                        response+= "</ul>";
                    }

                    message.show('danger',response);
                }
            },
            "submitHandler": function(form){
              if(typeof $(form).attr("data-form-beforesubmit") != "undefined"){
                var functionName = $(form).attr("data-form-beforesubmit").split(".");
                var functionMethod = window;
                for(var i=0; i<functionName.length;i++){
                  functionMethod = functionMethod[functionName[i]];
                }

                return functionMethod();
              }
              return true;
            }
        });
      }
    };

    this.bind = function() {
        this.validate();
    };
};

$(document).ready(function() {
    if (document.querySelector('form'))
      form.bind();

    if(typeof $(".verticalcarousel").owlCarousel !== "undefined" && $(".verticalcarousel").length > 0){
      $(".verticalcarousel").owlCarousel({
          //loop: true,
          items: 1,
          nav: true,
          animateOut: 'fadeOut'
      });
    }
});

//# sourceMappingURL=subpage.js.map
